import config from "config";
import * as mouseflow from "utils/mouseflow";

const apiRequest = (method, url, body = {}) => {
  const urlencoded = new URLSearchParams();

  Object.keys(body).forEach((key) => {
    const value = body[key];

    urlencoded.append(key, value);
  });

  return fetch(config.api + url, {
    method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: urlencoded,
  })
    .then(async (response) => {
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson ? await response.json() : await response.text();

      // check for error response
      if (!response.ok) {
        return Promise.reject(new Error(data));
      }

      return data;
    })
    .catch((error) => {
      mouseflow.tag("api-error");

      return Promise.reject(error);
    });
};

export default apiRequest;
